/*
  <ia-ingredient-checker> — merchant-configurable ingredient checker block.

  Extends the existing <ingredient-checker> component (ingredient-checker-section.js,
  Firebase-backed) and overrides only the methods that hardcode UI strings, reading
  them from data-* attributes instead:
    data-label-analyze, data-label-reset, data-label-clogs, data-label-notes

  Both modules are loaded by blocks/ia-ingredient-checker.liquid; this one waits
  for the base element definition before registering.
*/
customElements.whenDefined('ingredient-checker').then(() => {
  const IngredientChecker = customElements.get('ingredient-checker');

  class IaIngredientChecker extends IngredientChecker {
    get labels() {
      return {
        analyze: this.dataset.labelAnalyze || 'analyze',
        reset: this.dataset.labelReset || 'analyze another product',
        clogs: this.dataset.labelClogs || 'is known to clog pores.',
        notes: this.dataset.labelNotes || "Sofie's notes:",
      };
    }

    setAnalyze() {
      this.checkerButton.dataset.currentAction = 'analyze';
      this.checkerButton.innerHTML = this.labels.analyze;
    }

    handleCheckersubmit(event) {
      super.handleCheckersubmit(event);

      // The base 'analyze' branch hardcodes the reset label — re-apply ours.
      if (this.checkerButton.dataset.currentAction === 'reset') {
        this.checkerButton.innerHTML = this.labels.reset;
      }
    }

    getTroubledElementsHTML() {
      return this.identifiedTroubledIngredients
        .map(({ name, notes }) => {
          const notesEl = notes?.length > 0
            ? `<br><span class="ia-ingredient-checker__notes">${this.labels.notes} ${notes}</span>`
            : '';
          return `<li><strong>${name}</strong> ${this.labels.clogs}${notesEl}</li>`;
        })
        .join(' ');
    }
  }

  customElements.define('ia-ingredient-checker', IaIngredientChecker);
});
